webpackJsonp([114276838955818,60335399758886],{

/***/ 148:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Luk & Luk Niezależny Serwis BMW"}}},"layoutContext":{}}

/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(320);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(148);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(34);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _black = __webpack_require__(807);
	
	var _black2 = _interopRequireDefault(_black);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logoROstyle = {
	  backgroundImage: 'url(' + _black2.default + ')',
	  width: '60px',
	  height: '28px',
	  display: 'inline-block',
	  backgroundSize: 'cover',
	  backgroundPosition: 'center',
	  marginLeft: '10px'
	};
	
	var Footer = function Footer(_ref) {
	  var showContact = _ref.showContact;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'row dark-gray footer-row full-width padding-top-30 padding-bottom-50' },
	      !showContact ? _react2.default.createElement(
	        'div',
	        { className: 'row padding-bottom-30 mobile-center' },
	        _react2.default.createElement(
	          'div',
	          { className: 'column column-1-3' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'contact-details-list' },
	            _react2.default.createElement(
	              'li',
	              { className: 'sl-small-location-map middle-size-center' },
	              _react2.default.createElement(
	                'p',
	                null,
	                'Huzarska 12',
	                _react2.default.createElement('br', null),
	                '47-400 Racib\xF3rz'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'column column-1-3' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'contact-details-list' },
	            _react2.default.createElement(
	              'li',
	              { className: 'sl-small-phone middle-size-center' },
	              _react2.default.createElement(
	                'p',
	                null,
	                'Biuro',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'a',
	                  { href: 'tel:+48 793 700 098', style: { color: '#FFF' } },
	                  '+48 793 700 098'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'column column-1-3' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'contact-details-list' },
	            _react2.default.createElement(
	              'li',
	              { className: 'sl-small-truck-tow middle-size-center' },
	              _react2.default.createElement(
	                'p',
	                null,
	                'Pomoc drogowa ',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'a',
	                  { href: 'tel:+48 728 913 865', style: { color: '#FFF' } },
	                  '+48 728 913 865'
	                )
	              )
	            )
	          )
	        )
	      ) : ' ',
	      _react2.default.createElement(
	        'div',
	        { className: 'row ' + (!showContact ? 'top-border page-padding-top' : ' ') },
	        _react2.default.createElement(
	          'div',
	          { className: 'column column-1-3' },
	          _react2.default.createElement(
	            'h6',
	            { className: 'box-header' },
	            'DANE KONTAKTOWE'
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'list simple margin-top-20' },
	            _react2.default.createElement(
	              'li',
	              null,
	              'Huzarska 12'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              '47-400 Racib\xF3rz'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                'Biuro:'
	              ),
	              _react2.default.createElement(
	                'a',
	                { href: 'tel:+48 793 700 098' },
	                '+48 793 700 098'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                'Kierownik serwisu:'
	              ),
	              _react2.default.createElement(
	                'a',
	                { href: 'tel:+48 531 700 092' },
	                '+48 531 700 092'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                'Dzia\u0142 cz\u0119\u015Bci u\u017Cywanych:'
	              ),
	              ' ',
	              _react2.default.createElement(
	                'a',
	                { href: 'tel:+48 531 778 719' },
	                '+48 531 778 719'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                'Dzia\u0142 cz\u0119\u015Bci nowych:'
	              ),
	              ' ',
	              _react2.default.createElement(
	                'a',
	                { href: 'tel:+48 731 828 666' },
	                '+48 731 828 666'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                'E-mail:'
	              ),
	              _react2.default.createElement(
	                'a',
	                { href: 'mailto:bmw.luk@op.pl' },
	                'bmw.luk@op.pl'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'social-icons margin-top-26' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('a', {
	                target: '_blank',
	                href: 'https://www.facebook.com/LUK-LUK-Auto-Serwis-Niezale%C5%BCny-Serwis-BMW-Racib%C3%B3rz-668943926599017/',
	                className: 'social-facebook',
	                title: 'facebook'
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'column column-1-3' },
	          _react2.default.createElement(
	            'h6',
	            { className: 'box-header' },
	            'NASZA OFERTA'
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'list margin-top-20' },
	            _react2.default.createElement(
	              'li',
	              { className: 'template-bullet' },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/uslugi/mechanika' },
	                'Mechanika'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: 'template-bullet' },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/uslugi/diagnostyka' },
	                'Diagnostyka / Kodowanie / Doposa\u017Canie pojazdu'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: 'template-bullet' },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/uslugi/naprawy-powypadkowe' },
	                'Naprawy powypadkowe'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: 'template-bullet' },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/uslugi/czesci-nowe-i-uzywane' },
	                'Cz\u0119\u015Bci nowe i potestowe oraz u\u017Cywane'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: 'template-bullet' },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/uslugi/motocykle' },
	                'Motocykle'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: 'template-bullet' },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/uslugi/profesjonalny-serwis-ogumienia' },
	                'Profesjonalny serwis ogumienia'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: 'template-bullet' },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/uslugi/pomoc-drogowa' },
	                'Pomoc drogowa'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'column column-1-3' },
	          _react2.default.createElement(
	            'h6',
	            { className: 'box-header' },
	            'GODZINY PRACY'
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'list simple margin-top-20' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                'Poniedzia\u0142ek:'
	              ),
	              '9:00 - 17:00'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                'Wtorek:'
	              ),
	              '9:00 - 17:00'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                '\u015Aroda:'
	              ),
	              '9:00 - 17:00'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                'Czwartek:'
	              ),
	              '9:00 - 17:00'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                'Pi\u0105tek:'
	              ),
	              '9:00 - 17:00'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                'Sobota:'
	              ),
	              'Nieczynne'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'row padding-top-bottom-30 copyright-wrapper' },
	      _react2.default.createElement(
	        'div',
	        { className: 'column column-1-2 align-left copyright-footer' },
	        _react2.default.createElement(
	          'span',
	          { className: 'copyright' },
	          '\xA9 2018 LUK & LUK Auto Serwis s.c. Wszelkie prawa zastrze\u017Cone'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'column column-1-2 align-right copyright-footer' },
	        _react2.default.createElement(
	          'span',
	          { className: 'copyright' },
	          'Realizacja: rzucokiem.pl'
	        ),
	        _react2.default.createElement('a', { style: logoROstyle, className: 'logo-ro', target: '_blank', href: 'https://www.rzucokiem.pl/' })
	      )
	    )
	  );
	};
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(34);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _logo = __webpack_require__(808);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _Logo = __webpack_require__(312);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var activeLinkStyle = {
	  color: '#1E69B8'
	};
	
	var Header = function (_Component) {
	  _inherits(Header, _Component);
	
	  function Header(props) {
	    _classCallCheck(this, Header);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      visibleMenu: false,
	      visibleSubMenu: false
	    };
	
	    _this.handleVisableMenu = _this.handleVisableMenu.bind(_this);
	    _this.handleVisableSubMenu = _this.handleVisableSubMenu.bind(_this);
	    return _this;
	  }
	
	  Header.prototype.handleVisableMenu = function handleVisableMenu() {
	    this.setState(function (oldState) {
	      return { visibleMenu: !oldState.visibleMenu };
	    });
	  };
	
	  Header.prototype.handleVisableSubMenu = function handleVisableSubMenu() {
	    this.setState(function (oldState) {
	      return { visibleSubMenu: !oldState.visibleSubMenu };
	    });
	  };
	
	  Header.prototype.render = function render() {
	    var _state = this.state,
	        visibleMenu = _state.visibleMenu,
	        visibleSubMenu = _state.visibleSubMenu;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'header-top-bar-container clearfix' },
	        _react2.default.createElement(
	          'div',
	          { className: 'header-top-bar' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'contact-details clearfix' },
	            _react2.default.createElement(
	              'li',
	              { className: 'template-phone' },
	              '+48 793 700 098'
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: 'template-mail' },
	              _react2.default.createElement(
	                'a',
	                { href: 'mailto:bmw.luk@op.pl' },
	                'bmw.luk@op.pl'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: 'template-clock' },
	              'Pon - Pt: 9:00 - 17:00'
	            )
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'social-icons' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('a', {
	                target: '_blank',
	                href: 'https://www.facebook.com/LUK-LUK-Auto-Serwis-Niezale%C5%BCny-Serwis-BMW-Racib%C3%B3rz-668943926599017/',
	                className: 'social-facebook',
	                title: 'facebook'
	              })
	            )
	          )
	        ),
	        _react2.default.createElement('a', { href: '#', className: 'header-toggle template-arrow-up' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'header-container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'vertical-align-table column-1-1' },
	          _react2.default.createElement(
	            'div',
	            { className: 'header clearfix' },
	            _react2.default.createElement(
	              'div',
	              { style: { position: 'relative' }, className: 'logo vertical-align-cell' },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/' },
	                _react2.default.createElement(_Logo2.default, { logo: _logo2.default })
	              )
	            ),
	            _react2.default.createElement(
	              'a',
	              { onClick: this.handleVisableMenu, className: 'mobile-menu-switch vertical-align-cell' },
	              _react2.default.createElement('span', { className: 'line' }),
	              _react2.default.createElement('span', { className: 'line' }),
	              _react2.default.createElement('span', { className: 'line' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'menu-container clearfix vertical-align-cell' },
	              _react2.default.createElement(
	                'nav',
	                null,
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'sf-menu' },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { exact: true, to: '/', activeStyle: activeLinkStyle },
	                      'G\u0142\xF3wna'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { to: '/o-nas', activeStyle: activeLinkStyle },
	                      'O nas'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { to: '/uslugi', activeStyle: activeLinkStyle },
	                      'Oferta'
	                    ),
	                    _react2.default.createElement(
	                      'ul',
	                      null,
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          _gatsbyLink2.default,
	                          { to: '/uslugi/mechanika' },
	                          'Mechanika'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          _gatsbyLink2.default,
	                          { to: '/uslugi/diagnostyka' },
	                          'Diagnostyka / Kodowanie / Doposa\u017Canie pojazdu'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          _gatsbyLink2.default,
	                          { to: '/uslugi/naprawy-powypadkowe' },
	                          'Naprawy powypadkowe'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          _gatsbyLink2.default,
	                          { to: '/uslugi/czesci-nowe-i-uzywane' },
	                          'Cz\u0119\u015Bci nowe i potestowe oraz u\u017Cywane'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          _gatsbyLink2.default,
	                          { to: '/uslugi/motocykle' },
	                          'Motocykle'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          _gatsbyLink2.default,
	                          { to: '/uslugi/profesjonalny-serwis-ogumienia' },
	                          'Profesjonalny serwis ogumienia'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          _gatsbyLink2.default,
	                          { to: '/uslugi/pomoc-drogowa' },
	                          'Pomoc drogowa'
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { to: '/certyfikaty', activeStyle: activeLinkStyle },
	                      'Certyfikaty'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      {
	                        to: '/kontakt',
	                        style: {
	                          padding: '0',
	                          height: '50px',
	                          display: 'flex',
	                          alignItems: 'center',
	                          marginLeft: '20px'
	                        },
	                        activeStyle: activeLinkStyle
	                      },
	                      _react2.default.createElement(
	                        'button',
	                        { className: 'nav-cta' },
	                        'Skontaktuj si\u0119'
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'mobile-menu-container' },
	                _react2.default.createElement('div', { className: 'mobile-menu-divider' }),
	                _react2.default.createElement(
	                  'nav',
	                  null,
	                  _react2.default.createElement(
	                    'ul',
	                    {
	                      style: visibleMenu ? { display: 'block' } : null,
	                      className: 'mobile-menu collapsible-mobile-submenus'
	                    },
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { to: '/' },
	                        'Home'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { to: '/o-nas' },
	                        'O nas'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { to: '/uslugi' },
	                        'Oferta'
	                      ),
	                      _react2.default.createElement('a', { href: '#', className: 'template-arrow-menu', onClick: this.handleVisableSubMenu }),
	                      _react2.default.createElement(
	                        'ul',
	                        { style: visibleSubMenu ? { display: 'block' } : null },
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { to: '/uslugi/mechanika' },
	                            'Mechanika'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { to: '/uslugi/diagnostyka' },
	                            'Diagnostyka / Kodowanie / Doposa\u017Canie pojazdu'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { to: '/uslugi/naprawy-powypadkowe' },
	                            'Naprawy powypadkowe'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { to: '/uslugi/czesci-nowe-i-uzywane' },
	                            'Cz\u0119\u015Bci nowe i potestowe oraz u\u017Cywane'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { to: '/uslugi/motocykle' },
	                            'Motocykle'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { to: '/uslugi/profesjonalny-serwis-ogumienia' },
	                            'Profesjonalny serwis ogumienia'
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { to: '/certyfikaty' },
	                        'Certyfikaty'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { to: '/kontakt' },
	                        'Kontakt'
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Header;
	}(_react.Component);
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 312:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Logo = function Logo(props) {
	  return _react2.default.createElement("img", { className: "mainLogo", src: props.logo, alt: "" });
	};
	
	exports.default = Logo;
	module.exports = exports["default"];

/***/ }),

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var iconStyle = {
	  fontSize: '30px'
	};
	
	var ScrollTopButton = function (_PureComponent) {
	  _inherits(ScrollTopButton, _PureComponent);
	
	  function ScrollTopButton(props) {
	    _classCallCheck(this, ScrollTopButton);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));
	
	    _this.state = {
	      visible: false
	    };
	
	    _this.navPositionFix = _this.navPositionFix.bind(_this);
	    _this.handleOnClick = _this.handleOnClick.bind(_this);
	    return _this;
	  }
	
	  ScrollTopButton.prototype.componentDidMount = function componentDidMount() {
	    document.addEventListener('scroll', this.navPositionFix);
	  };
	
	  ScrollTopButton.prototype.navPositionFix = function navPositionFix() {
	    this.scrollPosition = window.scrollY;
	    if (this.scrollPosition > 400) {
	      this.setState(function () {
	        return { visible: true };
	      });
	    } else {
	      this.setState(function () {
	        return { visible: false };
	      });
	    }
	  };
	
	  ScrollTopButton.prototype.handleOnClick = function handleOnClick() {
	    window.scrollTo({
	      top: 0,
	      behavior: 'smooth'
	    });
	  };
	
	  ScrollTopButton.prototype.render = function render() {
	    var visible = this.state.visible;
	
	    return visible ? _react2.default.createElement(
	      'button',
	      { onClick: this.handleOnClick, className: 'scroll-top', title: 'POWR\xD3T NA G\xD3R\u0118 STRONY' },
	      _react2.default.createElement('span', { style: iconStyle, className: 'template-arrow-up' })
	    ) : null;
	  };
	
	  return ScrollTopButton;
	}(_react.PureComponent);
	
	exports.default = ScrollTopButton;
	module.exports = exports['default'];

/***/ }),

/***/ 320:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(282);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(34);
	
	var _Header = __webpack_require__(311);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(310);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _ScrollTopButton = __webpack_require__(315);
	
	var _ScrollTopButton2 = _interopRequireDefault(_ScrollTopButton);
	
	__webpack_require__(437);
	
	__webpack_require__(440);
	
	__webpack_require__(435);
	
	__webpack_require__(439);
	
	__webpack_require__(434);
	
	__webpack_require__(438);
	
	__webpack_require__(436);
	
	__webpack_require__(442);
	
	__webpack_require__(443);
	
	__webpack_require__(441);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* CSS */
	var Layout = function Layout(_ref) {
	  var children = _ref.children,
	      location = _ref.location,
	      data = _ref.data;
	
	  var isKontakt = location.pathname === '/kontakt';
	  console.log(isKontakt, location.pathname);
	
	  return _react2.default.createElement(
	    'div',
	    { style: { position: 'relative' }, className: 'site-container' },
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: data.site.siteMetadata.title,
	      meta: [{ charset: 'UTF-8' }, {
	        name: 'description',
	        content: 'LUK & LUK Auto Serwis to Niezależny Serwis BMW. Jego siedziba znajduje się w Raciborzu, województwie śląskim od 2003 roku. Jako niezależny serwis BMW świadczymy bardzo szeroki zakres usług. Począwszy od okresowych przeglądów, wymiany opon i mechaniki, po kodowanie, zaawansowaną diagnostykę i naprawy powypadkowe.'
	      }, {
	        name: 'viewport',
	        content: 'width=device-width, initial-scale=1, maximum-scale=1.2'
	      }, {
	        name: 'format-detection',
	        content: 'telephone=no'
	      }]
	    }),
	    _react2.default.createElement(_Header2.default, { siteTitle: data.site.siteMetadata.title }),
	    _react2.default.createElement(
	      'div',
	      null,
	      children()
	    ),
	    _react2.default.createElement(_Footer2.default, { showContact: isKontakt }),
	    _react2.default.createElement(_ScrollTopButton2.default, null)
	  );
	};
	
	/* FONTS */
	
	
	Layout.propTypes = {
	  children: _propTypes2.default.func.isRequired,
	  data: _propTypes2.default.shape({}).isRequired
	};
	
	exports.default = Layout;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 434:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 435:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 436:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 437:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 438:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 439:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 440:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 441:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 442:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 443:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 807:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/black.fb3711df.svg";

/***/ }),

/***/ 808:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo.be7e5883.svg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-00f4df604066c1dc4ba1.js